import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DocumentoTicket } from '../../../../../core/modelos/documento_ticket';
import { FileManagerService } from '../../../file-manager/file-manager.service';
import { TicketsService } from '../../tickets.service';
import { NotificacionesService } from '../../../../../core/notificaciones/notificaciones.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'app-lista-adjuntos',
  templateUrl: './lista-adjuntos.component.html',
  styleUrls: ['./lista-adjuntos.component.scss']
})
export class ListaAdjuntosComponent implements OnInit {

  @Input() adjuntos: Array<DocumentoTicket>;
  @Input() esDetalle: boolean;
  @Output() anexoBorrado = new EventEmitter<any>();

  constructor(
    private fileManagerSrv: FileManagerService,
    private ticketsService: TicketsService,
    private notificaciones: NotificacionesService
  ) { }

  ngOnInit() {
  }
  descargarAnexo(anexo: DocumentoTicket) {
    this.fileManagerSrv.descargarAnexoTicket(anexo);
  }
  borrarAnexo(anexo: DocumentoTicket) {
    this.ticketsService.deleteAnexo(anexo.id).subscribe(
      data => {
        if (data.success) {
          // CUANDO LLEGA AQUI, PARA EL USUARIO YA ESTA ELIMINADO PORQUE NUNCA MAS LO VERA
          // TODO FEEDBACK POSITIVO      
          const component = this;              
          this.fileManagerSrv.deleteAnexo(anexo).send(function (error, datos) {
            if (error) {
              // TODO CONTROLAR ERROR
              console.log('Fichero no borrado');
            }
            else {
              // EXITO
              component.anexoBorrado.emit(true);
            }
          });
        } else {
          // TODO NO SE HA BORRADO ALERT
        }
      },
      err => {
        this.notificaciones.errorServidor(err.status);
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/main/content/tickets/components/lista-adjuntos/lista-adjuntos.component.ts